import React from 'react';
import { Check } from 'lucide-react';

/** Checkmarked list item used in service-page body copy. */
export function FeatureItem({
  children
}: {
  children: React.ReactNode;
}) {
  return <li className="flex items-start" data-id="element-173" data-mp="29wdk35euyuqh">
      <Check className="w-6 h-6 text-red-500 mr-3 shrink-0 mt-1" aria-hidden="true" data-id="element-174" data-mp="29vcbd7lbekbx" />
      <span data-id="element-175" data-mp="2dys2joem7sh8">{children}</span>
    </li>;
}